import { useState } from 'react';
import { Overlay, Modal, LeftSection, CreateButton, RightSection, Title, Input, Button, SmallText, ContentContainer, Label } from "./LoginComponent.style";
import HeaderModal from "../HeaderModal/HeaderModal";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const LoginModal = ({ onClose, onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      console.log('Attempting login with:', { username, password });
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/login`, { username, password });
      console.log('Login response:', response);
      if (response.data.success) {
        console.log('Login successful, user:', response.data.user);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        onLogin(response.data.user);
        navigate('/');
      } else {
        console.log('Login failed:', response.data.message);
        setError('Invalid credentials');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError('Contraseña o usuario incorrecto');
    }
  };
    return (
      <Overlay>
        <HeaderModal />
        <Modal>
          <LeftSection>
            <h1>¡BIENVENIDO!</h1>
            <hr />
            <p>Para acceder al contenido de Eupha introduzca el nombre de usuario y la contraseña que se le ha facilitado.</p>
            <CreateButton><button><Link to='/sign-up'>Solicitar creación de cuenta</Link></button></CreateButton>
          </LeftSection>
          <RightSection>
            <ContentContainer>
            <Title>Iniciar Sesión</Title>
            <Label>Usuario</Label>
            <Input 
              type="text" 
              placeholder="Usuario" 
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <Label>Contraseña</Label>
            <Input 
              type="password" 
              placeholder="Contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {error && <SmallText style={{ color: 'red', fontWeight: 'bold' }}>{error}</SmallText>}
            <Button 
            >
              <button onClick={(e) => {
                e.preventDefault();
                handleLogin();}}>Iniciar Sesión</button>
            </Button>
            <SmallText>¿Olvidaste tu contraseña?</SmallText>
            <SmallText>Restablecer contraseña</SmallText>
            </ContentContainer>
          </RightSection>
        </Modal>
      </Overlay>
    );
  };
  
  export default LoginModal;
